<template>
   <div>
       <div class="row">
           <div class="col-12">
               <div class="form-group">
                   <select name="statistics_type" id="statistics_type" class="form-control form-control-lg" v-model="statistics_type">
                       <option value="items_statistics">Priekšmetu statistika</option>
                       <option value="images_statistics">Pievienoto attēlu skaits</option>
                       <option value="scientific_description_statistics">Zinātnisko aprakstu skaits</option>
                       <option value="purchases">Iepirkumi</option>
                       <option value="items_statistics_detailed">Priekšmeti pēc ieguves veida</option>
                       <option value="inspection">Redaktora pārbaudes statistika</option>
                       <option value="user_statistics">Lietotāja statistika</option>
                       <option value="image_user_statistics">Lietotāja pievienotie attēli (no 5.12.2022.)</option>
                   </select>
               </div>
           </div>
           <div class="col-12">
               <hr>
           </div>
           <div class="col-12">
               <div class="row">
                   <div class="col-12" v-if="statistics_type == 'images_statistics' || statistics_type== 'scientific_description_statistics'">
                       <div class="alert alert-primary">Statistikas dati tiek attēlo pareizi tikai pēc dabubāzes atjaunošanas (01.10.2021.) ievadītiem datiem.</div>
                   </div>
                   <div class="col-2">
                       <label for="ciphers">Šifri</label>
                       <v-select
                           :multiple="true"
                           v-model="ciphers"
                           :options="item_ciphers"
                           :reduce="cipher => cipher.title"
                           label="title"/>
                       <small>Ja nav atlasīts neviens, tad rādīs visiem</small>
                   </div>
                   <div class="col-2" v-if="statistics_type=='items_statistics'">
                       <div class="form-group">
                           <label for="period_type">Perioda veids</label>
                           <select name="period_type" id="period_type" class="form-control" v-model="period_type">
                               <option value="by_item_date">Priekšmeta ievades datums</option>
                               <option value="by_act_date">Akta datums</option>
                           </select>
                       </div>
                   </div>
                   <div class="col-2" v-if="statistics_type=='items_statistics'">
                       <div class="form-group">
                           <label for="period_type">Grupēt pēc</label>
                           <select name="group_by" id="group_by" class="form-control" v-model="group_by">
                               <option value="cipher">Šifra</option>
                               <option value="transfer_type_id">Ieguves veida</option>
                               <option value="collection_id">Kolekcijas</option>
                               <option value="title_id">Nosaukuma</option>
                               <option value="scientific_theme_id">Zinātniskās tēmas</option>
                           </select>
                       </div>
                   </div>
                   <div class="col-2">
                       <div class="form-group">
                           <label for="date_from">Datums no</label>
                           <v-date-picker
                               :popover="{ visibility: 'click' }"
                               mode="single"
                               v-model="date_from"
                               :type="'date'"
                               :locale="'LV'"
                               color="teal"
                               :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                           />
                       </div>
                   </div>
                   <div class="col-2">
                       <div class="form-group">
                           <label for="date_from">Datums līdz</label>
                           <v-date-picker
                               :popover="{ visibility: 'click' }"
                               mode="single"
                               v-model="date_to"
                               :type="'date'"
                               :locale="'LV'"
                               color="teal"
                               :masks="{
                                            input: ['DD.MM.YYYY']
                                        }"
                           />
                       </div>
                   </div>
                   <div class="col-2">
                       <div class="actions">
                           <form action="/statistics/get" method="POST">
                               <input type="hidden" name="_token" :value="csrf">
                               <input type="hidden" name="statistics_type" :value="statistics_type">
                               <input type="hidden" name="ciphers" :value="ciphers">
                               <input type="hidden" name="period_type" :value="period_type">
                               <input type="hidden" name="group_by" :value="group_by">
                               <input type="hidden" name="date_from" :value="JSON.stringify(date_from)">
                               <input type="hidden" name="date_to" :value="JSON.stringify(date_to)">
                               <button class="btn btn-primary" formtarget="_blank">Izgūt statistikas pārskatu</button>
                           </form>
                       </div>
                   </div>

               </div>
           </div>
       </div>
   </div>
</template>
<script>
export default{
    props:['item_ciphers'],
    data()
    {
        return {
            ciphers:"",
            statistics_type:"items_statistics",
            group_by:"cipher",
            date_from:"",
            date_to:"",
            period_type:"by_item_date",
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')

        }
    },
}
</script>

<style lang="scss">
.actions{
    height:100%;
    display:flex;
    align-items: center;
    justify-content: center;
}

</style>
